import { Icon } from 'antd';
import styled from 'styled-components';
import { IconLinkContainer } from './style';

export const IconLink = styled.a`
    line-height: 32px;
    display: inline-block;
    margin-left: 26px;
    font-size: 14px;
`;

const svg = () => (
    <svg
        version="1.1"
        x="0px"
        y="0px"
        width="22px"
        height="22px"
        viewBox="0 0 512 512"
        xmlSpace="preserve">
        <g fillRule="evenodd" clipRule="evenodd" fill="#262626" id="vk_._logo_._social_._media__x2C__icon">
            <path
                d="M425.614 86.344C382.172 42.91 322.258 16.066 255.96 16.066c-66.297 0-126.212 26.844-169.654 70.277-43.438 43.447-70.277 103.494-70.277 169.654 0 66.297 26.839 126.211 70.277 169.659 43.442 43.438 103.357 70.276 169.654 70.276 66.298 0 126.212-26.839 169.654-70.276 43.438-43.448 70.282-103.362 70.282-169.659 0-66.159-26.843-126.206-70.282-169.653zm-13.282 326.154C372.339 452.486 317.071 477.2 255.96 477.2s-116.379-24.714-156.372-64.702c-40.112-40.121-64.826-95.385-64.826-156.5 0-61.107 24.714-116.375 64.826-156.363C139.581 59.646 194.849 34.8 255.96 34.8s116.379 24.847 156.372 64.835c40.117 39.988 64.821 95.256 64.821 156.363 0 61.115-24.704 116.379-64.821 156.5z"/>
            <path
                d="M388.678 189.175c-3.586-2.654-16.471-2.654-29.224-2.654-13.021.265-26.044.265-29.101 1.462-2.782 1.061-9.028 16.207-17.129 31.746-9.308 17.545-20.593 34.547-27.771 34.272-9.43 0-7.168-28.826-6.506-50.209.128-13.954-2.129-18.474-4.121-19.661-4.917-3.459-18.464-6.771-18.464-6.771s-40.661-3.062-46.367 14.475c7.836 1.064 21.123-1.334 15.941 53.001-.397 2.664-6.246 24.979-25.111-5.181-4.784-7.566-22.846-52.869-29.224-53.134-20.867-.402-41.583-1.33-48.751 2.654-6.781 3.989 9.028 35.072 35.734 76.793 21.648 34.272 44.635 60.847 84.491 67.485 7.571.804 26.972 1.59 33.218-1.325 4.111-1.997-1.069-31.485 13.149-34.415 6.246-1.191 30.549 30.828 39.714 34.415 5.594 2.257 17.811 3.185 30.298 2.649 13.552-.393 28.954 1.335 30.416-7.963 3.327-20.328-41.039-46.907-42.24-59.39-1.065-9.033 16.211-25.637 24.974-38.394 10.888-15.411 22.855-34.007 16.074-39.855z"/>
        </g>
    </svg>
);

export default function VkLink({ href, title }) {
    return <IconLinkContainer>
        <Icon component={svg} style={{width: 32, top: 6, left: -5, position: 'absolute'}}/>
        <IconLink href={href} target='_blank' rel='noopener noreferrer'>{title ? title : href}</IconLink>
    </IconLinkContainer>
}

